import { render, staticRenderFns } from "./KindergartenEdit.vue?vue&type=template&id=36b95fb2&scoped=true"
import script from "./KindergartenEdit.vue?vue&type=script&lang=js"
export * from "./KindergartenEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b95fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b95fb2')) {
      api.createRecord('36b95fb2', component.options)
    } else {
      api.reload('36b95fb2', component.options)
    }
    module.hot.accept("./KindergartenEdit.vue?vue&type=template&id=36b95fb2&scoped=true", function () {
      api.rerender('36b95fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/kindergartens/KindergartenEdit.vue"
export default component.exports